import axios from 'axios'

const UNKNOWN_FILENAME_STR = 'Untitled file'

const getFilenameFromHeaders = (headers) => {
  const disposition = headers?.['content-disposition']
  if (!disposition) {
    return UNKNOWN_FILENAME_STR
  }

  // Попробуем найти filename*=utf-8''... (RFC 5987)
  const filenameStarRegex = /filename\*=utf-8''([^;\n]*)/i
  const filenameStarMatch = filenameStarRegex.exec(disposition)
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      return decodeURIComponent(filenameStarMatch[1])
    } catch (e) {
      // Failed to decode filename from content-disposition
    }
  }

  // Fallback на обычный filename=...
  if (disposition && (disposition.indexOf('attachment') !== -1 || disposition.indexOf('inline') !== -1)) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(disposition)
    if (matches != null && matches[1]) {
      return decodeURIComponent(matches[1]).replace(/utf-8|['"]/g, '')
    }
  }
  return UNKNOWN_FILENAME_STR
}


export const downloadBlob = (blob, fileName, options = { isNewTab: false }) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob)
    return
  }


  const data = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  if (options.isNewTab) {
    link.target = '_blank'
  }
  link.href = data
  if (fileName) {
    link.download = fileName
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)


  // For Firefox it is necessary to delay revoking the ObjectURL
  setTimeout(() => { window.URL.revokeObjectURL(data) }, 100)
}

export const download = (url, fileName, options = { isNewTab: false }) => {
  const link = document.createElement('a')
  if (options.isNewTab) {
    link.target = '_blank'
  }
  link.href = url
  if (fileName) {
    link.download = fileName
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadLink = async (link, fileName, options) => {
  const { data } = await axios.post(link, null, { responseType: 'blob' })
  downloadBlob(data, fileName, options)
}

export const downloadLinkByGet = async (link, fileName, options, config) => {
  const { data, headers } = await axios.get(link, { ...config, responseType: 'blob' })
  let fn = fileName
  if (!fileName) {
    fn = getFilenameFromHeaders(headers)
  }
  downloadBlob(data, fn, options)
}

export const downloadLinkByPost = async (link, postData, fileName, options) => {
  const { data, headers } = await axios.post(link, postData, { responseType: 'blob' })
  let fn = fileName
  if (!fileName) {
    fn = getFilenameFromHeaders(headers)
  }
  downloadBlob(data, fn, options)
}
